import { useState, useEffect } from 'react';
import api from '../utils/api';

/**
 * Jangkauan kumulatif CLP sepanjang waktu (all-time, tidak per-batch/cohort) --
 * fetch sekali saat mount, tidak ada dependency. Dipisah dari useDashboardData
 * (yang sudah fetch 6 dataset lain, sebagian tidak dipakai) supaya hook ini
 * tetap kecil dan jelas tujuannya.
 */
export default function useClpReach() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.analyticsClpReach();
        setData(res);
      } catch (err) {
        console.error('analyticsClpReach error:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
}
